// Стили
import "./style/footer.scss";

// Svg
import {DiscordSvg} from "../svgs";

// Consts
import {DS_URL_WE, DS_URL_TVOK} from "../consts";

export function Footer() {
    return (
        <footer>
            <div className="footer">
                <p className="center_text">
                    Создатели сайта:<br/>
                    <a href="https://t.me/VeBrau" target="_blank">@VeBray</a>,{" "}
                    <a href="https://t.me/JustCheburek" target="_blank">@JustCheburek</a>,{" "}
                    <a href="">@K1Ms17</a>
                </p>
                <p className="small">
                    Not an official Minecraft product. We are in no way affiliated with or endorsed by Mojang Synergies
                    AB, Microsoft Corporation or other rightsholders.
                </p>

                <div className="url_section">
                    {/* Навигация по ссылкам */}
                    <a target="_blank" href={DS_URL_TVOK} className="url_box" rel="noopener">
                        <div className="url ds">
                            <DiscordSvg/>
                        </div>
                        Коалиция
                    </a>

                    <a target="_blank" href={DS_URL_WE} className="url_box" rel="noopener">
                        <img src="/media/we.png" alt="WE" className="we url"/>
                        Проект
                    </a>
                </div>
            </div>
        </footer>
    )
}